import React from 'react';
import './BenefitsSection.scss';

const BenefitsSection = () => {
  const benefits = [
    {
      title: 'Tailored to your business',
      description: 'Our powerful AI chatbots are incredibly flexible and completely adaptable to the unique and ever-evolving demands of your business.',
      icon: 'settings.svg'
    },
    {
      title: 'Efficiency-boosting technology',
      description: 'Get instantaneous, intelligent responses to a near-limitless range of queries and requests. Dramatically cut resolution times and improve the overall efficiency.',
      icon: 'lightbulb.svg'
    },
    {
      title: 'Cost-effective assistance',
      description: 'Embrace the next technological step for business workflow. Get next-generation capabilities for a fraction of the price of hiring skilled support workers.',
      icon: 'mind-icon.svg'
    }
  ];

  return (
    <section className="benefits section">
      <div className="benefits__background"></div>
      <div className="container">
        <div className="grid grid--3-cols">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefits__item">
              <div className="benefits__icon">
                <img
                  src={require(`../assets/images/${benefit.icon}`)}
                  alt={benefit.title}
                />
              </div>
              <h3 className="benefits__title">{benefit.title}</h3>
              <p className="benefits__description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection; 
